<template>
  <div class="app-container">
    <el-card class="operate-container" shadow="never" style="margin-top: 0px">
      <div class="filter-container">
        <el-form
          ref="queryForm"
          :inline="true"
          :model="queryParam"
          label-width="70px"
        >
          <el-form-item label="手机号:" prop="phone">
            <el-input
              v-model="queryParam.phone"
              placeholder="请输入手机号"
              style="width: 147px"
            ></el-input>
          </el-form-item>
          <el-form-item label="会员名:" prop="name">
            <el-input
              v-model="queryParam.name"
              placeholder="请输入"
              style="width: 147px"
            ></el-input>
          </el-form-item>
          <el-form-item label="版本:" label-width="110px" prop="templateId">
            <el-select
              v-model="queryParam.templateId"
              clearable
              placeholder="请选择"
              style="width: 147px"
              @change="changeLessonIdC"
            >
              <el-option
                v-for="item in [
                  { label: 'A', value: 2 },
                  { label: 'B', value: 1 },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="消费类型:"
            label-width="80px"
            prop="storeLessonsId"
          >
            <el-select
              v-model="queryParam.storeLessonsId"
              clearable
              placeholder="请选择"
              style="width: 147px"
            >
              <el-option
                v-for="item in storeLessonExpCards"
                :key="item.storeLessonId"
                :label="item.name"
                :value="item.storeLessonId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间:" prop="typeTime">
            <el-select
              v-model="queryParam.typeTime"
              clearable
              placeholder="请选择"
              style="width: 147px"
            >
              <el-option
                v-for="item in [
                  { label: '最近七天', value: 1 },
                  { label: '最近一月', value: 2 },
                  { label: '最近三月', value: 3 },
                  { label: '最近一年', value: 4 },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: 30px">
            <el-button
              type="primary"
              size="medium"
              class="operator-btn"
              icon="el-icon-search"
              @click="onBtnSearch()"
              >查 询</el-button
            >
            <el-button
              type="warning"
              size="medium"
              class="operator-btn2"
              icon="el-icon-refresh"
              @click="handleResetSearch()"
              style="margin-left: 30px"
              >重 置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="app-container-content">
      <div class="title-container" shadow="never" style="padding-top: 20px">
        <div></div>
        <div class="spec-buton-box">
          <el-button
            type="primary"
            size="medium"
            class="operator-btn"
            icon="el-icon-circle-plus-outline"
            @click="clickOpenTrue()"
            >操 作</el-button
          >
          <img class="spec-img" src="@/statics/imgs/vip.png" alt="" />
        </div>
      </div>
      <div class="table-container" style="margin-top: 20px">
        <el-table
          ref="tableData"
          style="width: 100%"
          :data="tableData"
          max-height="520"
          v-loading="tableloading"
          border
          :highlight-current-row="false"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          @row-click="rowClick"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="卡ID" prop="id" width="120">
          </el-table-column>
          <el-table-column label="创建日期" prop="createTime" width="160">
          </el-table-column>
          <el-table-column label="版本" prop="templateName" width="120">
          </el-table-column>
          <el-table-column label="购买人手机号" prop="phoneNumber" width="120">
          </el-table-column>
          <el-table-column label="会员姓名" prop="childrenName" width="120">
          </el-table-column>
          <el-table-column label="卡名称" prop="cardName" width="120">
          </el-table-column>
          <el-table-column label="价格(元)" prop="valueMoney">
          </el-table-column>
          <el-table-column label="优惠金额(元)" prop="givenPay" width="110">
          </el-table-column>
          <el-table-column label="实付金额(元)" prop="totalPay" width="110">
          </el-table-column>
          <el-table-column label="有效期(天)" prop="days" width="90">
          </el-table-column>
          <el-table-column label="总课时" prop="totalLesssonCount">
          </el-table-column>
          <el-table-column label="赠送课时" prop="totalGiveCount">
          </el-table-column>
          <el-table-column label="状态" prop="statu">
            <template slot-scope="{ row }">
              {{ row.statu == 0 ? "启用" : "停用" }}
            </template>
          </el-table-column>
          <el-table-column label="渠道" prop="source"> </el-table-column>
          <el-table-column label="邀约人" prop="inviteName">
          </el-table-column>
          <el-table-column label="销售" prop="marketNames">
            <template slot-scope="{ row }">
              {{ getMarketNames(row.marketNames) }}
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="">
            <template slot-scope="scope">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <p>{{ scope.row.remark }}</p>
                <img @click="clickAudio(scope.row)" v-if="scope.row.recording"
                  style="width: 25px; height: 25px; margin-left: 5px;cursor: pointer;"
                  src="@/assets/icons/laba.png"
                  alt=""
                />
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="clickDelRowData(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>

    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage"
      >
      </el-pagination>
    </div>

    <template v-if="visibleOrderTrue">
      <el-dialog
        title="订单确认"
        :visible.sync="visibleOrderTrue"
        width="1000px"
        center
      >
        <orderCom
          :orderInfo="selectRow"
          @onBtnCancel="visibleOrderTrue = false"
          @handleUpdate="handleOrderComUpdate"
        />
      </el-dialog>
    </template>
    <template v-if="audioDialog">
      <el-dialog title="音频文件" width="500px" :visible.sync="audioDialog" center>
        <audioDialog ref="audioDialogRef" />
      </el-dialog>
    </template>
  </div>
</template>

<script>
import commonUtils from "@/utils/commonUtils";
import messageUtils from "@/utils/messageUtils";
import globaldata from "@/utils/globaldata";
import { saleOrderList } from "@/api/saleOrder";
import { selectCards } from "@/api/storeFront";
import audioDialog from "@/components/audioDialog";
import orderCom from "./components/order";
export default {
  components: { audioDialog,orderCom },
  data() {
    return {
      audioDialog: false,
      queryParam: {
        //分页查询
        pageNum: 1, //当前第几页
        totalPage: 1, //总共页数
        phone: undefined, //手机号
        name: undefined, //会员名
        templateId: null, //消费类型
        storeLessonsId: null, //版本
        typeTime: undefined,
        pageSize: 10,
        pageSizes: [10, 20, 30],
      },
      tableData: [],
      tableloading: false,
      selectRow: null,
      multipleSelection: [],
      visibleOrderTrue: false,
      storeLessonExpCards: [], //版本
      isVip: globaldata.getAdminStore().isVip,
    };
  },

  mounted() {
    this.getSaleOrderList();
  },

  methods: {
    clickAudio(val) {
      this.audioDialog = true
      console.log(val,this.$refs.audioDialogRef,'refs.audioDialogRef=======')
      this.$nextTick(()=>{
        this.$refs.audioDialogRef.audio = val.recording
      })
    },
    // 获取销售列表数据
    async getSaleOrderList() {
      let params = {
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        pageNum: this.queryParam.pageNum,
        pageSize: this.queryParam.pageSize,
        phone: this.queryParam.phone,
        name: this.queryParam.name, //会员名
        templateId: this.queryParam.templateId, //版本
        storeLessonsId: this.queryParam.storeLessonsId,
        typeTime: this.queryParam.typeTime,
      };
      this.tableloading = true;
      const response = await saleOrderList(params);
      console.log(response, "response");
      this.tableloading = false;
      let data = response.data;
      if (commonUtils.isObjectNull(data)) {
        return;
      }
      this.tableData = data.records;
      this.queryParam.totalPage = data.total;
      this.tableloading = false;
    },
    getMarketNames(val) {
      let str = "";
      if (val && val.length) {
        val.forEach((element) => {
          str += element + "、";
        });
        return str;
      } else {
        return str;
      }
    },
    changeLessonIdC(e) {
      console.log("changeLessonIdC", e);
      if (e) {
        this.getStoreLessonCard(e);
      } else {
        this.$set(this.queryParam, "storeLessonsId", null);
        this.storeLessonExpCards = [];
      }
    },
    async getStoreLessonCard(lessonId) {
      let self = this;
      const response = await selectCards({
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        statu: 0,
        exp: 1,
        lessonId,
      });
      if (response.code === 20000) {
        self.storeLessonExpCards = response.data;
      }
    },
    handleOrderComUpdate() {
      this.visibleOrderTrue = false;
      this.handleResetSearch()
    },
    clickOpenTrue() {
      // if (!this.handleCheckSelect()) {
      //   return;
      // }
      if (this.isVip == 0) return this.$message.warning("该功能需要开通VIP功能，请先开通相关权益！");
      if(this.multipleSelection.length == 0 || this.multipleSelection.length>1){
        messageUtils.errorMsg(this, "请先选择一条信息");
        return 
      }
      this.selectRow = this.multipleSelection[0]
      console.log(this.selectRow, "this.selectRow");
      this.visibleOrderTrue = true;
    },
    //点击查询按钮
    onBtnSearch() {
      this.getSaleOrderList();
    },
    // 重置查询按钮
    handleResetSearch() {
      this.queryParam.pageNum = 1;
      this.$refs.queryForm.resetFields();
      this.storeLessonExpCards = [];
      this.onBtnSearch();
    },
    rowClick(row, column, event) {
      this.selectRow = row;
      console.log(this.selectRow,'this.selectRow1')
    },
    handleCheckSelect() {
      if (commonUtils.isObjectNull(this.selectRow)) {
        messageUtils.errorMsg(this, "请先选择一条信息");
        return false;
      }
      return true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    clickDelRowData(row) {},
    handleSizeChange(val) {
      this.queryParam.pageSize = val;
      this.getSaleOrderList()
    },
    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.getSaleOrderList()
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table th.el-table__cell > .cell {
  // width: 90%;
  height: 100%;
  background: #ecf3fd;
  // border-radius: 8px;
}
/deep/ .el-table__header-wrapper .cell {
  line-height: 45px;
  color: #0d6fb8;
}
/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}
/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}

.app-container {
  .operate-container {
    border: none;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  /deep/ .el-card__body {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  &-content {
    background: #ffffff;
    border-radius: 8px;
    margin-top: 20px;
  }
  .table-container {
    border: none;
    border-radius: 0px;
    /deep/ .el-table {
      .el-table__header-wrapper {
        .el-table__cell {
          padding: 0px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/saleOrder/index.vue